import { useEffect, useState } from 'react';
import { MATERIAL_QUOTE_CATEGORIES, SUB_QUOTE_CATEGORIES, ALL_CATEGORIES } from '../utils/categories';

// Categories are managed in Settings → Categories and stored in the DB. This hook
// fetches them once (module-cached, shared across components) and falls back to
// the hardcoded defaults if the API is unreachable, so dropdowns never go blank.
const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }

let cache = null;
let inflight = null;
const listeners = new Set();

function load(force) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = fetch(`${API_BASE}/categories`, { headers: { 'x-worker-token': getToken() } })
    .then(r => (r.ok ? r.json() : Promise.reject()))
    .then(rows => { cache = Array.isArray(rows) ? rows : []; inflight = null; listeners.forEach(l => l(cache)); return cache; })
    .catch(() => { inflight = null; return null; });
  return inflight;
}

export function refreshCategories() { return load(true); }

export function useCategories() {
  const [rows, setRows] = useState(cache);
  useEffect(() => {
    const l = r => setRows(r);
    listeners.add(l);
    load();
    return () => listeners.delete(l);
  }, []);
  const has = Array.isArray(rows) && rows.length > 0;
  const material = has ? rows.filter(c => c.kind === 'material').map(c => c.name) : MATERIAL_QUOTE_CATEGORIES;
  const sub = has ? rows.filter(c => c.kind === 'sub').map(c => c.name) : SUB_QUOTE_CATEGORIES;
  const all = has ? Array.from(new Set(rows.filter(c => c.kind === 'material' || c.kind === 'sub').map(c => c.name))) : ALL_CATEGORIES;
  // The drills (Settings → Categories): one list per drilling workflow. Falls back to the
  // three vertical drills the app always had if the list has not loaded yet.
  const verticalDrills = has ? rows.filter(c => c.kind === 'vertical_drill').map(c => c.name) : ['Volvo', 'Ella', 'Harold'];
  const directionalDrills = has ? rows.filter(c => c.kind === 'directional_drill').map(c => c.name) : [];
  const drillsFor = type => (type === 'horizontal_drilling' ? directionalDrills : type === 'vertical_drilling' ? verticalDrills : [...verticalDrills, ...directionalDrills]);
  return { material, sub, all, verticalDrills, directionalDrills, drillsFor, loaded: has };
}
